import React from 'react';

const StartingVariationLimitModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#222',
          border: '2px solid #3066be',
          borderRadius: '8px',
          padding: '30px',
          maxWidth: '450px',
          width: '90%',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#ff0050',
            marginBottom: '20px'
          }}
        >
          Starting Variation Limit
        </div>
        
        <div
          style={{
            fontSize: '16px',
            color: '#ccc',
            marginBottom: '25px',
            lineHeight: '1.5'
          }}
        >
          Only one starting variation is allowed at this moment, more coming soon
        </div>
        
        <button
          onClick={onClose}
          style={{
            backgroundColor: '#3066be',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 30px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#4088ee';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#3066be';
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default StartingVariationLimitModal;